import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Dialog from '@material-ui/core/Dialog';

const composeClassName = (defaultClassName, customClassName) => classnames({
    [customClassName]: !!customClassName,
    [defaultClassName]: true,
});

export const Modal = (props) => {
    const { DialogContentProps, theme, children, className, classes = {}, BackdropProps = {}, ...rest } = props;
    return (
        <Dialog
            { ...rest }
            className={ composeClassName(theme.dialog, className) }
            classes={{
                ...classes,
                paper: composeClassName(theme.paper, classes.paper),
            }}
            maxWidth="md"
            BackdropProps={{ className: composeClassName(theme.backdrop, BackdropProps.className) }}
        >
            { children }
        </Dialog>
    );
};

Modal.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    DialogContentProps: PropTypes.shape({}),
    className: PropTypes.string,
    classes: PropTypes.shape({}),
    BackdropProps: PropTypes.shape({}),
    theme: PropTypes.shape({}),
    children: PropTypes.node.isRequired,
};

export default Modal;
